<template>
    <text-dialog :value.sync="dialog" title="Eintrag bearbeiten" confirm :confirm-label="'save'" :confirm-disabled="!valid" @ok="ok" :disabled="disabled">
        <slot name="activator" slot="activator" />
        <div slot="content">
            <v-form v-model="valid" v-if="editEntry">
                <v-container>
                    <v-layout wrap row>
                        <v-flex xs12 md12>
                            <v-text-field
                                v-model="editEntry.title"
                                :rules="rules.titleRules"
                                label="Titel"
                                required
                            />
                        </v-flex>

                        <v-flex xs12 md12>
                            <v-text-field
                                v-model="editEntry.duration"
                                :rules="rules.durationRules"
                                label="Dauer (min)"
                                required
                            />
                        </v-flex>

                        <v-flex xs12 md12>
                            <v-text-field
                                :disabled="!canEditStartAt"
                                v-model="editEntry.start_at"
                                :rules="rules.startAtRules"
                                label="Startzeitpunkt"
                                required
                            />
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-form>
        </div>
    </text-dialog>
</template>

<script>
    import { mapMutations } from 'vuex';
    import TextDialog from '../dialogs/TextDialog';

    export default {
        components: {
            TextDialog
        },
        props: {
            entry: {
                type: Object,
                default: null
            },
            disabled: {
                type: Boolean,
                default: false
            },
            canEditStartAt: {
                type: Boolean,
                default: false
            }
        },
        data: () => ({
            dialog: false,
            loading: false,
            valid: false,
            editEntry: null,
            rules: {
                titleRules: [
                    v => !!v || 'Titel ist Pflichtfeld'
                ],
                durationRules: [
                    v => !!v || 'Dauer ist Pflichtfeld',
                    v => /^\d{1,4}$/.test(v) || 'Falsches Format',
                    v => +v >= 1 || 'Mindestens eine Minute',
                ],
                startAtRules: [
                    v => !!v || 'Startzeitpunkt ist Pflichtfeld',
                    v => /^\d\d\d\d-(0?[1-9]|1[0-2])-(0?[1-9]|[12][0-9]|3[01]) (0?[0-9]|1[0-9]|2[0-3]):(0?[0-9]|[0-5][0-9]):(0?[0-9]|[0-5][0-9])$/.test(v) || 'Falsches Format (jjjj-mm-tt hh:mm:ss)'
                ],
            }
        }),
        watch: {
            dialog() {
                if (this.dialog) {
                    this.editEntry = _.cloneDeep(this.entry);
                }
            }
        },
        mounted() {
            this.editEntry = _.cloneDeep(this.entry);
        },
        methods: {
            ok() {
                this.dialog = false;
                this.$emit('ok', this.editEntry);
            }
        }
    }
</script>